module.exports = "/_next/static/images/contact-duotone-a09db05559e968d583e9926539761aac.svg";